// SKR (Safe Keeping Receipt) data store.
// Records are persisted in the browser (localStorage) so admin entries survive reloads.
// This is a prototype store — swap for a real backend/database when ready.
export type StoredItem = {
  id: string
  category: string // e.g. Precious Metals, Documents, Jewelry, Art
  description: string
  quantity: string // free text so "3 bars" / "1 set" etc. all work
  estimatedValue: string // display string, e.g. "$120,000"
}
export type SKRRecord = {
  code: string // 7- or 8-digit code as printed on the receipt
  holderName: string
  accountRef: string
  facility: string
  issueDate: string // ISO date
  expiryDate: string // ISO date
  status: 'Active' | 'Released' | 'On Hold'
  items: StoredItem[]
  notes?: string
}
const STORAGE_KEY = 'steca_skr_records_v1'
const SEED: SKRRecord[] = [
  {
    code: '48120736',
    holderName: 'Jonathan A. Meyer',
    accountRef: 'STG-2026-0142',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-01-14',
    expiryDate: '2027-01-14',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metals',
        description: 'Gold bullion bars, 1kg, 999.9 fine (LBMA)',
        quantity: '5 bars',
        estimatedValue: '$325,000',
      },
      {
        id: 'i2',
        category: 'Precious Metals',
        description: 'Silver coins, 1oz American Eagle',
        quantity: '200 coins',
        estimatedValue: '$6,400',
      },
      {
        id: 'i3',
        category: 'Documents',
        description: 'Sealed legal deed envelope',
        quantity: '1 envelope',
        estimatedValue: '—',
      },
    ],
    notes: 'Deposited under dual-custody protocol. Insurance policy STG-INS-0142.',
  },
  {
    code: '90057214',
    holderName: 'Amara Okafor',
    accountRef: 'STG-2026-0189',
    facility: 'Dar es Salaam Vault — Chamber 1',
    issueDate: '2026-03-02',
    expiryDate: '2027-03-02',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Jewelry',
        description: 'Diamond necklace set, GIA certified',
        quantity: '1 set',
        estimatedValue: '$210,000',
      },
      {
        id: 'i2',
        category: 'Fine Art',
        description: 'Framed oil painting (private collection)',
        quantity: '1 piece',
        estimatedValue: '$85,000',
      },
    ],
    notes: 'Climate-controlled storage. Handling requires two authorized signatures.',
  },
  {
    code: '91199202',
    holderName: 'GEN DAVID MUTOMBO MAWAMBA & Mr. JEAN LUC SAFARI',
    accountRef: 'STG-2026-0142',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-07-17',
    expiryDate: '2027-08-17',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'N/A',
        description: 'FOUR BALLETS CONTAIN 200.14KG',
        quantity: 'N/A',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Cargo details are confidential.',
  },
  {
    code: '91199201',
    holderName: 'MR KABAMBA TOTTI KELVINE',
    accountRef: 'STG-2026-01222',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-07-10',
    expiryDate: '2027-07-10',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Minerals (Gold)',
        description: '250 KILOGRAMS OF GOLD',
        quantity: '250KGS',
        estimatedValue: 'N/S',
      },
    ],
  },
  {
    code: '17171227',
    holderName: 'AMANI MICHAEL',
    accountRef: 'STG-2026-1845746',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-07-23',
    expiryDate: '2027-08-23',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Minerals (Gold)',
        description: 'TWO BOXES OF GOLD NUGGETS — 550 KILOGRAMS OF GOLD',
        quantity: '550KGS',
        estimatedValue: 'N/S',
      },
    ],
  },
  {
    code: '12056975',
    holderName: 'METALS TRADE LTD',
    accountRef: 'STG-2025-1845746',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2025-11-03',
    expiryDate: '2026-11-03',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Minerals (Gold)',
        description: 'FOUR BOXES OF GOLD NUGGETS — 2,000 KILOGRAMS OF GOLD',
        quantity: '2,000KGS',
        estimatedValue: 'N/S',
      },
    ],
  },
  {
    code: '1845746',
    holderName: 'MR FRANCK MULUMBA PASPORT',
    accountRef: 'STG-2026-18191998',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-07-31',
    expiryDate: '2026-07-31',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Minerals (Gold)',
        description: 'FOUR BOXES OF RAW GOLD — 3,500 KILOGRAMS OF GOLD',
        quantity: '3,500KGS',
        estimatedValue: 'N/S',
      },
    ],
    notes: 'Company: GLOBAL MINING CONGO SARL.',
  },
  {
    code: '81182022',
    holderName: 'MR EMILE NGINDU MUTOMBO',
    accountRef: 'STC-2026-18191779',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-08-24',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '50 KILOGRAMS',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: N/A.',
  },
  {
    code: '30181820',
    holderName: 'MR JEREMIA PUPA BOKEBE',
    accountRef: 'STC-2026-77918819',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-08-24',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '580 KILOGRAMS',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: N/A.',
  },
  {
    code: '30181821',
    holderName: 'CRISTIN MONGI MONGOLARE (PASSPORT NUMBER OP1720820)',
    accountRef: 'STC-2026-77918867',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-06-20',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '1,200 KILOGRAMS',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: ACRO MINING LICENSE.',
  },
  {
    code: '12122112',
    holderName: 'MR ROGERS RAMADHANI KILLO',
    accountRef: 'STC-2026-17170022',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-08-17',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '50 KILOGRAMS',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: N/A.',
  },
  {
    code: '80080012',
    holderName:
      'SHABUNDA MINERALS LOGISTICS DR. CONGO & LALSHRQ FOR TRADE IN PRECIOUS AND PRECIOUS METALS SAOUD JASSIM S A QATARI',
    accountRef: 'STC-2026-18220182',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-08-29',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '10 KILOGRAMS',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: N/A.',
  },
  {
    code: '88808008',
    holderName:
      'SHABUNDA MINERALS LOGISTICS DR. CONGO & LALSHRQ FOR TRADE IN PRECIOUS AND PRECIOUS METALS SAOUD JASSIM S A QATARI',
    accountRef: 'STC-2026-30012121',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-08-29',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '580 KILOGRAMS OF RAW GOLD',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: N/A.',
  },
  {
    code: '44622144',
    holderName: 'LAOS BULLION BANK',
    accountRef: 'STC-2026-00525211',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-08-28',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '1,200 KILOGRAMS OF AU',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: LAOS BULLION BANK.',
  },
  {
    code: '62622620',
    holderName: 'KOKATE JOACHIM',
    accountRef: 'STC-2026-12200020',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-10-05',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'Metal boxes with 2 padlocks',
        quantity: '300 KILOGRAMS OF RAW GOLD',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: XYZ Import-Export.',
  },
  {
    code: '82008242',
    holderName: 'PAUL LINDWA KASESE',
    accountRef: 'STC-2026-32321211',
    facility: 'Dar es Salaam Vault — Chamber 3',
    issueDate: '2026-09-28',
    expiryDate: 'N/A',
    status: 'Active',
    items: [
      {
        id: 'i1',
        category: 'Precious Metal',
        description: 'STC BOX OF GOLD BARS',
        quantity: '435 KILOGRAMS OF RAW GOLD',
        estimatedValue: 'N/A',
      },
    ],
    notes: 'Company: N/A.',
  },
]
// Vault-issued receipts are always kept in sync with the seed data, so they stay
// verifiable for visitors whose browser saved an older copy of the records.
const VAULT_ISSUED_CODES = [
  '91199202',
  '91199201',
  '17171227',
  '12056975',
  '1845746',
  '81182022',
  '30181820',
  '30181821',
  '12122112',
  '80080012',
  '88808008',
  '44622144',
  '62622620',
  '82008242',
]
function read(): SKRRecord[] {
  if (typeof window === 'undefined') return SEED
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(SEED))
      return SEED
    }
    const records = JSON.parse(raw) as SKRRecord[]
    const vaultIssued = SEED.filter((record) => VAULT_ISSUED_CODES.includes(record.code))
    const updatedRecords = vaultIssued.reduce<SKRRecord[]>((current, issued) => {
      return current.some((record) => record.code === issued.code)
        ? current.map((record) => (record.code === issued.code ? issued : record))
        : [...current, issued]
    }, records)
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(updatedRecords))
    return updatedRecords
  } catch {
    return SEED
  }
}
function write(records: SKRRecord[]): void {
  if (typeof window === 'undefined') return
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(records))
}
export function getAllRecords(): SKRRecord[] {
  return read()
}
export function findByCode(code: string): SKRRecord | undefined {
  const clean = code.trim()
  return read().find((r) => r.code === clean)
}
export function saveRecord(record: SKRRecord): { ok: boolean; error?: string } {
  const records = read()
  const idx = records.findIndex((r) => r.code === record.code)
  if (idx >= 0) {
    records[idx] = record
  } else {
    records.push(record)
  }
  write(records)
  return { ok: true }
}
export function deleteRecord(code: string): void {
  write(read().filter((r) => r.code !== code))
}
export const ITEM_CATEGORIES = [
  'Precious Metals',
  'Jewelry',
  'Fine Art',
  'Documents',
  'Watches',
  'Collectibles',
  'Other',
]
